import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Head from '../../../layout/head/Head';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../../../components/Component';
import Content from '../../../layout/content/Content';
import { Badge, Button } from 'reactstrap';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { RETRIEVE_TENANT_AGENCY_DETAILS_API } from '../../../api/api_data';
import { fail_retrieve_tenant_agency_details, loading_retrieve_tenant_agency_details, reset_retrieve_tenant_agency_details, success_retrieve_tenant_agency_details } from '../../../reducers/auth_tenant/retrieve_tenant_agency_details_Slice';
import { RETRIEVE_TENANT_AGENCY_DETAILS_ERROR_MSG, RETRIEVE_TENANT_AGENCY_DETAILS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import CardTabs from '../../components/cards/CardTabs';
import AddSalesRepToAgencyModal from '../../../components/modal/AddSalesRepToAgencyModal';
import moment from 'moment';
import ViewAgencyMainSalesRepModal from '../../../components/modal/ViewAgencyMainSalesRepModal';
import ViewAgencyOrderAproversModal from '../../../components/modal/ViewAgencyOrderAproversModal';
import AgencyViewSalesRepDetailsModal from '../../../components/modal/AgencyViewSalesRepDetailsModal';

const AgencyDetails = ({ tenant_info, user_info }) => {

  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [add_sales_rep_modal, setAddSalesRepModal] = useState(false);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [main_sales_rep_modal, setMainSalesRepModal] = useState(false);
  const [order_approval_modal, setOrderApprovalModal] = useState(false);
  const [sales_rep_id, setSalesRepId] = useState("");
  const [view_sales_rep_modal, setViewSalesRepModal] = useState(false);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Sales Reps"
    },
    {
      tabName: "Settings"
    },
  ];

  useEffect(() => {
    retrieve_agency_details();
  }, []);

  const retrieve_agency_details = () => {
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_agency_details, success_retrieve_tenant_agency_details, fail_retrieve_tenant_agency_details, RETRIEVE_TENANT_AGENCY_DETAILS_ERROR_MSG, RETRIEVE_TENANT_AGENCY_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_AGENCY_DETAILS_API}/${id}`));
  };

  // Listener
  const retrieve_tenant_agency_details_listener = useSelector((state) => state.retrieve_tenant_agency_details.retrieve_tenant_agency_details);

  useEffect(() => {
    if (retrieve_tenant_agency_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_agency_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_agency_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_agency_details_listener.message);
          messageToast(retrieve_tenant_agency_details_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_agency_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_agency_details_listener.data);
          setCurrentPageData(retrieve_tenant_agency_details_listener.data?.sales_reps);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_agency_details());
      }
    }
  }, [retrieve_tenant_agency_details_listener]);

  const open_add_sales_reps_modal = () => {
    setAddSalesRepModal(true);
  };

  const close_add_sales_reps_modal = () => {
    setAddSalesRepModal(false);
  };


  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  const open_main_sales_rep_modal = () => {
    setMainSalesRepModal(true);
  };

  const close_main_sales_rep_modal = () => {
    setMainSalesRepModal(false);
  };

  const open_order_approval_modal = () => {
    setOrderApprovalModal(true);
  };

  const close_order_approval_modal = () => {
    setOrderApprovalModal(false);
  };

  const open_view_sales_rep_modal = (id) => {
    setViewSalesRepModal(true);
    setSalesRepId(id);
  };

  const close_view_sales_rep_modal = () => {
    setViewSalesRepModal(false);
    setSalesRepId("");
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Agency Details` : " Agency Details"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>Agency Details</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/agencies`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/${tenant_info?.url_prefix}/agencies`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Agency Details..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && (page_data?.length > 0 || page_data !== null) ?
                        <>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                          {
                            activeCardTab === "Main Info" && (
                              <>
                                <div className="card-inner bg-white">
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Main Info</BlockTitle>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Name</span>
                                          <span className="profile-ud-value">{page_data?.name || "--"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Email Address</span>
                                          <span className="profile-ud-value">{page_data?.email_address || "--"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Mobile Number</span>
                                          <span className="profile-ud-value">{page_data?.mobile_number || "--"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">No of Sales Reps</span>
                                          <span className="profile-ud-value">{page_data?.sales_reps?.length || "0"}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </Block>
                                </div>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Sales Reps" && (
                              <>
                                <div className="card-inner">
                                  <Block>
                                    <BlockBetween className="mb-4">
                                      <BlockHeadContent>
                                        <BlockTitle tag="h5">Sales Reps</BlockTitle>
                                      </BlockHeadContent>
                                      <BlockHeadContent >
                                      </BlockHeadContent>
                                      {
                                        (user_info?.roles?.includes(app_consts.ADD_AGENCY) || user_info?.roles?.includes(app_consts.ADMINISTRATOR) || user_info?.roles?.includes(app_consts.ADD_SALES_REP)) && (
                                          <>
                                            <div className="toggle-wrap nk-block-tools-toggle">
                                              <div className="toggle-expand-content">
                                                <ul className="nk-block-tools g-3">
                                                  <li>
                                                    <div className="tb-odr-btns d-sm-inline">
                                                      <Button color="primary" size="sm" onClick={() => open_add_sales_reps_modal()}>
                                                        Add Sales Rep
                                                      </Button>
                                                    </div>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </>
                                        )
                                      }
                                    </BlockBetween>

                                    {
                                      page_data?.sales_reps && page_data?.sales_reps?.length > 0 ?
                                        <>
                                          <div className="nk-tb-list is-separate is-medium mb-3">
                                            <DataTableHead className="nk-tb-item">
                                              <DataTableRow>
                                                <span className="sub-text">Username</span>
                                              </DataTableRow>
                                              <DataTableRow size="mb">
                                                <span className="sub-text">Type</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Date Created</span>
                                              </DataTableRow>
                                              <DataTableRow size="lg">
                                                <span className="sub-text">Last Login</span>
                                              </DataTableRow>
                                              <DataTableRow size="md">
                                                <span className="sub-text">Status</span>
                                              </DataTableRow>
                                              <DataTableRow size="md">
                                                <span className="sub-text">Action</span>
                                              </DataTableRow>
                                            </DataTableHead>
                                            {/* Head */}
                                            {currentItems.length > 0
                                              ? currentItems.map((item) => (
                                                <DataTableItem key={item.id}>
                                                  <DataTableRow>
                                                    <Link to={`/${tenant_info.url_prefix}/sales_rep/${item?.account?.mobile_number}`}>
                                                      <div className="user-card">
                                                        <div className="user-info">
                                                          <span className="tb-lead">
                                                            {item?.name ? item?.name : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                                          </span>
                                                          <span>{item?.email_address || "--"}  | {item?.mobile_number || "--"} </span>
                                                        </div>
                                                      </div>
                                                    </Link>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span>{item?.type || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="mb">
                                                    <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span className="tb-odr-date">{item?.last_login ? moment(item?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span className="tb-odr-status">
                                                      <Badge
                                                        color={
                                                          item?.status === app_consts.ACTIVE
                                                            ? "success"
                                                            : "danger"
                                                        }
                                                        className="badge-dot"
                                                      >
                                                        {item?.status?.toUpperCase() || "--"}
                                                      </Badge>
                                                    </span>
                                                  </DataTableRow>
                                                  <DataTableRow className="nk-tb-col-tools">
                                                    <div className="tb-odr-btns d-none d-sm-inline">
                                                      <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_sales_rep_modal(item?.id)}>
                                                        View
                                                      </Button>
                                                    </div>
                                                    <Button className="btn-pd-auto d-sm-none" onClick={() => open_view_sales_rep_modal(item?.id)}>
                                                      <Icon name="chevron-right"></Icon>
                                                    </Button>
                                                  </DataTableRow>
                                                </DataTableItem>
                                              ))
                                              : null}
                                          </div>
                                          {currentItems?.length > 0 && (
                                            <div className="mt-3">
                                              <PaginationComponent
                                                itemPerPage={itemPerPage}
                                                totalItems={current_page_data?.length}
                                                paginate={paginate}
                                                currentPage={currentPage}
                                              />
                                            </div>
                                          )}
                                          <AgencyViewSalesRepDetailsModal isOpen={view_sales_rep_modal} closeModal={close_view_sales_rep_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_agency_details} data={{ id: id, sales_rep_id: sales_rep_id }} />
                                        </>
                                        :
                                        <>
                                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Sales Reps Found"} />
                                        </>
                                    }
                                  </Block>
                                </div>
                                <AddSalesRepToAgencyModal isOpen={add_sales_rep_modal} successFunction={retrieve_agency_details} closeModal={close_add_sales_reps_modal} tenant_info={tenant_info} user_info={user_info} />
                              </>
                            )
                          }
                          {
                            activeCardTab === "Settings" && (
                              <>
                                <Block className='my-3'>
                                  <Row className="g-gs">
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="user-fill" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Main Sales Rep</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Set: </span> <span>{page_data?.settings?.main_sales_rep ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_main_sales_rep_modal} color="primary">
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    {/* <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="check-c" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Order Approvers</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Set: </span> <span>{page_data?.settings?.approver_one && page_data?.settings?.approver_two ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_order_approval_modal} color={"primary"}>
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col> */}
                                  </Row>
                                </Block>
                                <ViewAgencyMainSalesRepModal tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_agency_details} isOpen={main_sales_rep_modal} closeModal={close_main_sales_rep_modal} />
                                <ViewAgencyOrderAproversModal tenant_info={tenant_info} user_info={user_info} successFunction={retrieve_agency_details} closeModal={close_order_approval_modal} isOpen={order_approval_modal} />
                              </>
                            )
                          }
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Agency Information Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default AgencyDetails;